import './style.css';
import { installerJournalErreurs } from './lib/error-journal.js';
import { IDENVA_CALLBACK_CHANNEL, isIdenvaCallback, relayIdenvaCallback } from './lib/idenva-link.js';
import { mountApp } from './ui/app.js';

// Branche avant tout le reste : une erreur du montage doit deja etre notee. Aucun transport n'est passe -- Klavox
// n'a pas de canal bêta, donc rien ne sort (decision du porteur, 2026-10-14) ; le journal reste en memoire, lisible
// sur demande depuis les Parametres (« Copier le journal d'erreurs »).
const { journal } = installerJournalErreurs(window);

const root = document.getElementById('app');
if (root === null) {
  throw new Error('#app introuvable dans index.html');
}

if (isIdenvaCallback(window.location.href)) {
  // Fenetre de liaison Idenva qui revient : on remet l'adresse a l'onglet du
  // coffre, on efface le code de la barre d'adresse et on se ferme. Le coffre
  // ne s'ouvre jamais ici.
  relayIdenvaCallback(window.location.href, new BroadcastChannel(IDENVA_CALLBACK_CHANNEL));
  window.history.replaceState(null, '', '/');
  root.textContent = 'Liaison Idenva transmise a Klavox : vous pouvez fermer cette fenetre.';
  window.close();
} else {
  // La PWA est servie par son serveur Klavox (meme origine que /v1) : s'il a Idenva, l'accueil commence par Idenva.
  // Un hebergement statique sans /v1 ne repond pas a la configuration Idenva -- accueil local, comme avant.
  mountApp(root, { journalErreurs: journal, homeServer: window.location.origin });
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Le mode hors-ligne est un confort, pas une exigence de securite : un
      // echec d'enregistrement (navigateur non compatible, contexte non https)
      // ne doit pas empecher le coffre de fonctionner.
    });
  });
}
